import "./styles.css";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

declare global {
  interface Window {
    __LANDRR_DATA__?: Record<string, Record<string, unknown>>;
  }
}

const basename = import.meta.env.BASE_URL.replace(/\/$/, "");

hydrateRoot(
  document.getElementById("app")!,
  <StrictMode>
    <BrowserRouter basename={basename || undefined}>
      <App initialRouteData={window.__LANDRR_DATA__ ?? {}} />
    </BrowserRouter>
  </StrictMode>
);
